import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import {
    AllCasesPage,
    CaseWorkflowHistoryPage,
    ClosedCasesPage,
    InstitutionAdminsPage,
    InternalDashboardPage,
    MyCasesPage,
    PendingBankCasesPage,
    TeamLeadAssignedCasesPage,
    UnassignedBreachedCasesPage,
    UserCreatePage,
    UserPermissionsPage,
    UserRolesPage,
    UsersPage,
    FaqsPage,
    AuditsPage,
    ExternalUserPage,
    ExternalUserCreatePage,
    CategoriesPage,
    SubCategoriesPage,
    ReportedInstitutionsPage,
} from '../pages';
import EscalatedCases from '../pages/internal/caseMgt/EscalatedCases';
import Help from '../pages/internal/Help';
import Institutions from '../pages/internal/institutions';
import InstitutionCreate from '../pages/internal/institutions/InstitutionCreate';
import InstitutionTypes from '../pages/internal/institutions/InstitutionTypes';
import RegulatoryDirectives from '../pages/internal/institutions/RegulatoryDirectives';
import Sanctions from '../pages/internal/institutions/Sanctions';
import TechnicalSessions from '../pages/internal/institutions/TechnicalSessions';
import Warnings from '../pages/internal/institutions/Warnings';
import Reports from '../pages/internal/Reports';
import ReturnSubmission from '../pages/internal/ReturnSubmission';
import Teams from '../pages/internal/UserMgt/Teams';
import { getPrivilegeStatus } from '../util';
import Bank2BankBreachedCases from '../pages/internal/caseMgt/Bank2BankBreachedCases';
import RootCauseAnalysis from '../pages/internal/caseMgt/RootCauseAnalysis';
import CaseDetailsPage from '../pages/internal/caseMgt/CaseDetailsPage';

const InternalRoutes = () => {
    const { path, url } = useRouteMatch();

    const PermissionRoute = ({ component: Component, exact = false, id, ...rest }) => {
        return <Route {...rest} render={(props) => (getPrivilegeStatus(id) || !id ? <Component {...props} /> : <Redirect to={`/unauthorized`} />)} exact={exact} />;
    };

    return (
        <Switch>
            <Route exact path={`${path}`}>
                <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/case-management`}>
                <Redirect to={`${path}/case-management/all-cases`} />
            </Route>
            <Route exact path={`${path}/institution`}>
                <Redirect to={`${path}/institution/all`} />
            </Route>
            <Route exact path={`${path}/owned-cases`}>
                <Redirect to={`${path}/owned-cases/cases`} />
            </Route>
            <Route exact path={`${path}/users`}>
                <Redirect to={`${path}/users/all`} />
            </Route>
            <PermissionRoute exact path={`${path}/dashboard`} component={InternalDashboardPage} id="" /> {/* getDashboardStatsForLoggedInInternalUser- */}
            <PermissionRoute exact path={`${path}/return-processing`} component={ReturnSubmission} id="GetCasesUploadSummaryForCPD" />
            <PermissionRoute exact path={`${path}/reports`} component={Reports} />
            <PermissionRoute exact path={`${path}/help`} component={Help} />
            <PermissionRoute exact path={`${path}/owned-cases/cases`} component={MyCasesPage} id="getLoggedInUserAssignedCases" />
            <PermissionRoute exact path={`${path}/owned-cases/pending-bank-cases`} component={PendingBankCasesPage} id="getMyPendingBankCases" />
            {/* <PermissionRoute exact path={`${path}/owned-cases/workflow-history`} component={CaseWorkflowHistoryPage} /> */}
            <PermissionRoute exact path={`${path}/case-management/all-cases`} component={AllCasesPage} id="getAllCases" />
            <PermissionRoute exact path={`${path}/case-management/closed-cases`} component={ClosedCasesPage} id="getAllClosedCases" />
            <PermissionRoute exact path={`${path}/case-management/escalated-cases`} component={EscalatedCases} id="" />
            <PermissionRoute exact path={`${path}/case-management/unassigned-breached-cases`} component={UnassignedBreachedCasesPage} id="getUnassignedBreachedCases" />
            <PermissionRoute exact path={`${path}/case-management/bank-to-bank-breached-cases`} component={Bank2BankBreachedCases} />
            <PermissionRoute exact path={`${path}/case-management/teamlead-assigned-cases`} component={TeamLeadAssignedCasesPage} id="getTeamLeadAssignedCases" />
            <PermissionRoute exact path={`${path}/case-management/reported-institutions`} component={ReportedInstitutionsPage} id="getAllReportedFIsCases" />
            <PermissionRoute exact path={`${path}/case-management/root-cause-analysis`} component={RootCauseAnalysis} id="GetRootCauseAnalysisUploadForInstitution" />
            <PermissionRoute exact path={`${path}/case-management/:case_id`} component={CaseDetailsPage} id="getAllCases" />
            <PermissionRoute exact path={`${path}/users/all`} component={UsersPage} id="getAllUsers" />
            <PermissionRoute exact path={`${path}/users/create`} component={UserCreatePage} id="createInternalUser" />
            <PermissionRoute exact path={`${path}/users/user/:userId`} component={UserCreatePage} id="getUserDetailsById" />
            <PermissionRoute exact path={`${path}/users/external`} component={ExternalUserPage} id="getAllUsers" />
            <PermissionRoute exact path={`${path}/users/external/create`} component={ExternalUserCreatePage} id="createExternalUser" />
            <PermissionRoute exact path={`${path}/users/external/user/:userId`} component={ExternalUserCreatePage} id="getUserDetailsById" />
            <PermissionRoute exact path={`${path}/institution/all`} component={Institutions} />
            <PermissionRoute exact path={`${path}/institution/create`} component={InstitutionCreate} />
            <PermissionRoute exact path={`${path}/institution/inst/:instId`} component={InstitutionCreate} id="getInstitutionById" />
            <PermissionRoute exact path={`${path}/institution/admins`} component={InstitutionAdminsPage} />
            <PermissionRoute exact path={`${path}/institution/types`} component={InstitutionTypes} />
            <PermissionRoute exact path={`${path}/institution/regulatory-directives`} component={RegulatoryDirectives} id="getAllRegulatoryDirectives" />
            <PermissionRoute exact path={`${path}/institution/warnings`} component={Warnings} id="getAllWarnings" />
            <PermissionRoute exact path={`${path}/institution/sanctions`} component={Sanctions} id="getAllSanctions" />
            <PermissionRoute exact path={`${path}/institution/technical-sessions`} component={TechnicalSessions} id="getAllTechnicalSessions" />
            <PermissionRoute exact path={`${path}/roles`} component={UserRolesPage} id="getAllRoles" />
            <PermissionRoute exact path={`${path}/audits`} component={AuditsPage} id="GetAllAuditTrail" />
            <PermissionRoute exact path={`${path}/faqs`} component={FaqsPage} id="GetAllFAQs" />
            <PermissionRoute exact path={`${path}/category/all`} component={CategoriesPage} />
            <PermissionRoute exact path={`${path}/category/sub-categories`} component={SubCategoriesPage} id="getAllSubcategories" />
            <PermissionRoute exact path={`${path}/permissions`} component={UserPermissionsPage} />
            <PermissionRoute exact path={`${path}/teams`} component={Teams} id="getAllTeams" />
        </Switch>
    );
};

export default InternalRoutes;
